import AddButton from './AddButton'

function ListField({
   label,
   fieldKey,
   field,
   addHandler,
   setHandler,
   placeholder,
}) {
   return (
      <div className="group-list">
         <div className="group-list-header">
            <label>{label}</label>
            <AddButton onClick={() => addHandler(fieldKey)} />
         </div>
         <div className="nodes">
            {field[fieldKey].map((node, i) => (
               <div className="node-row" key={node.id}>
                  <span className="node-index">{i + 1}</span>
                  <input
                     type="text"
                     id={node.id}
                     value={node.value}
                     placeholder={placeholder}
                     onChange={e => setHandler(e, fieldKey)}
                  />
               </div>
            ))}
         </div>
      </div>
   )
}

export default ListField
